import { render, staticRenderFns } from "./PoliticasDatos.vue?vue&type=template&id=4bddbe1f"
import script from "./PoliticasDatos.vue?vue&type=script&lang=js"
export * from "./PoliticasDatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports